import { io } from "socket.io-client";
import Cookies from "js-cookie";

class SocketService {
  socket = null;

  connect() {
    if (this.socket && this.socket.connected) {
      return;
    }

    try {
      this.socket = io(process.env.REACT_APP_SOCKET_URL, {
        transports: ["websocket"],
        auth: {
          token: `carrum ${Cookies.get("authToken")}`, // Pass token for authentication
        },
        reconnection: true, // Enable reconnection
        reconnectionAttempts: Infinity, // Retry up to 3 times
        reconnectionDelay: 1000, // Delay of 1 second between retries
        reconnectionDelayMax: 5000, // Maximum delay between retries (5 seconds)
        timeout: 10000, // Timeout for the connection attempt (10 seconds)
      });

      this.socket.on("connect", () => {
        // retryCount = 0; // Reset retry count upon successful connection
      });

      // socket.on("disconnect", () => {

      //     //retry
      // });

      // Show notification on disconnect
      this.socket.on("disconnect", (reason) => {
        // showNotification("Disconnected. Please check your connection and Refresh.", "error"); // Show error message
      });

      // Show notification on connection error
      this.socket.on("connect_error", (err) => {
        console.error("Connection error:", err.message);
        // showNotification(`${err.message}: Failed to connect. Please check your Connection and Refresh`, "error");; // Show error message
      });

      // Show notification for general errors
      this.socket.on("error", (err) => {
        console.error("Socket error:", err.message);
        // showNotification(`Socket error: ${err.message}`, "error"); // Show error message
      });
      // Handle reconnection failure
      this.socket.on("reconnect_error", (err) => {
        console.error("Reconnection failed:", err.message);
        // showNotification(`Reconnection failed. Please Refresh: ${err.message}`, "error");
      });

      // Handle max reconnection attempts
      this.socket.on("reconnect_failed", () => {
        // showNotification("Failed to reconnect. Please try again later.", "error");
      });

      // return socket; //
    } catch (error) {
      console.error("Error establishing WebSocket connection:", error);
      // showNotification("Error establishing WebSocket connection: " + error.message, "error"); // Show error message
    }
  }

  emit(event, payload) {
    if (this.socket) {
      this.socket.emit(event, payload);
    }
  }

  on(event, callback) {
    if (this.socket) {
      this.socket.on(event, callback);
    }
  }

  off(event, callback) {
    if (this.socket) {
      this.socket.off(event, callback);
    }
  }

  disconnect() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }

  isConnected() {
    return this.socket?.connected || false;
  }
}

const socketService = new SocketService();
export default socketService;

export const connectSocket = (token) => socketService.connect(token);
export const emitSocket = (event, payload) => socketService.emit(event, payload);
export const onSocket = (event, callback) => socketService.on(event, callback);
export const offSocket = (event, callback) => socketService.off(event, callback);
export const disconnectSocket = () => socketService.disconnect();
export const isSocketConnected = () => socketService.isConnected();
